/*
 * @Author       : LQ
 * @Description  :
 * @version      : 1.0
 * @Date         : 2021-08-20 16:44:21
 * @LastAuthor   : LQ
 * @lastTime     : 2021-08-20 17:14:53
 * @FilePath     : /u-view2.0/uview-ui/libs/config/props/list.js
 */
export default {
    // list 组件
    list: {
        showScrollbar: false,
        lowerThreshold: 50,
        upperThreshold: 0,
        scrollTop: 0,
        offsetAccuracy: 10,
        enableFlex: false,
        pagingEnabled: false,
        scrollable: true,
        scrollIntoView: '',
        scrollWithAnimation: false,
        enableBackToTop: false,
        height: 0,
        width: 0,
        preLoadScreen: 1
    }
}
